import { render, staticRenderFns } from "./StrapiActualiteComponent.vue?vue&type=template&id=815f5b3c"
import script from "./StrapiActualiteComponent.vue?vue&type=script&lang=js"
export * from "./StrapiActualiteComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports